import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
import { getClientMessages, getModalMessages } from '../../../../../constants/messages';
import AllProgrammedDeactivationsView from './View';

let clientMessages = getClientMessages(),
	modalMessages = getModalMessages();

const messages = {
	...clientMessages,
	...modalMessages,
};

class GPDModal extends React.Component {
	getIntl = (str, values = {}) => this.props.intl.formatMessage({ ...messages[str] }, values);

	renderButtons = () => {
		const { props, getIntl } = this;
		const { handleCancel } = props;
		return [
			<Button key="close" onClick={handleCancel}>
				{getIntl('close')}
			</Button>,
		];
	};

	render() {
		const { props, getIntl, renderButtons } = this;
		const { showModal, handleCancel } = props;
		return (
			<Modal
				open={showModal}
				title={getIntl('programmedDeactivations')}
				onCancel={handleCancel}
				destroyOnClose={true}
				footer={renderButtons()}
				width={1040}
			>
				<AllProgrammedDeactivationsView />
			</Modal>
		);
	}
}

GPDModal.propTypes = {
	intl: PropTypes.object.isRequired,
	showModal: PropTypes.bool.isRequired,
	handleCancel: PropTypes.func.isRequired,
};

export default injectIntl(GPDModal);
